import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Sort, SortDirection } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Product } from 'src/app/classes';
import { HiddenInputDirective } from 'src/app/lib/shared/directives/hidden-input.directive';
import { IssueItem } from '../../../classes';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-issue-items-form2',
  templateUrl: './issue-items-form2.component.html',
  styleUrls: ['./issue-items-form2.component.css']
})
export class IssueItemsForm2Component implements OnDestroy, OnInit {

  @Input() disabled: boolean = false;

  columns: string[] = ['position', 'name', 'count', 'product', 'description', 'info', 'setupcost', 'rentalcost', 'purchasecost', 'contract', 'booked', 'controls'];
  footerColumns: string[] = ['position', 'setupcost', 'rentalcost', 'purchasecost', 'controls'];
  numberTypes: string[] = ['itemposition', 'itemcount', 'itemsetupcost', 'itemrentalcost', 'itempurchasecost'];

  totalRentalCost: number = 0;
  totalPurchaseCost: number = 0;
  totalSetupCost: number = 0;

  updateItemOnProductChange: boolean = true;

  formGroup: FormGroup;

  active = 'itemposition';
  direction: SortDirection = 'asc';

  private _subscriptions: Subscription[] = [];

  constructor(
    private _controlContainer: ControlContainer,
    private _formBuilder: FormBuilder,
    private _issueService: IssueService,
    private _changeRef: ChangeDetectorRef
  ) { }

  addArticle() {
    this._issueService.addIssueItem(this.itemControl, this._formBuilder);
  }

  itemIsEmpty(item: IssueItem): boolean {
    return !item || (!item.itemdesc && !item.itemproduct && !item.itemname && !item.iteminfo && !item.itempurchasecost && !item.itemrentalcost && !item.itemsetupcost!);
  }

  itemProductChanged(product: Product, group: FormGroup) {
    if (
      this.updateItemOnProductChange
      && product
      && !group.controls['itemname'].value
      && !group.controls['itemdesc'].value
      && !group.controls['itempurchasecost'].value
      && !group.controls['itemrentalcost'].value
      && !group.controls['itemsetupcost'].value
    ) {
      group.controls['itemname'].setValue(product.productservice);
      group.controls['itemdesc'].setValue(product.productdesc);
      group.controls['itempurchasecost'].setValue(product.productpurchasecost);
      group.controls['itemrentalcost'].setValue(product.productrentalcost);
      group.controls['itemsetupcost'].setValue(product.productsetupcost);
      this.updateCosts();
    }
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({ items: this._controlContainer.control as FormArray });

    this.formGroup
      .valueChanges
      .pipe(debounceTime(200))
      .subscribe({ next: () => this.updateCosts() });

    this.updateCosts();
  }

  normalizePositions() {
    var position = 1;
    for (let index in this.itemControl.controls) {
      (this.itemControl.controls[index] as FormGroup)
        .controls['itemposition']
        .setValue(position);
      position++;
    }
  }

  proxyFocus = (ref: HiddenInputDirective) => ref.focus();

  removeEmptyItems() {
    if (this.itemControl.length === 0) return;

    var index = 0;

    var currentItem = this
      .itemControl
      .controls[index];

    while (currentItem) {
      if (this.itemIsEmpty(currentItem.value)) {
        this.removeItem(index);
      } else index++;
      currentItem = this
        .itemControl
        .controls[index];
    }
  }

  removeItem(key: number) {
    if (this.itemControl.controls[key]) {
      this.itemControl.removeAt(key);
      this.updatePurchaseCost();
      this.updateRentalCost();
      this.updateSetupCost();
    }
  }

  sortData(sort: Sort) {
    this.direction = sort.direction;
    this.active = sort.active;
  }

  updateCosts() {
    this.updatePurchaseCost();
    this.updateRentalCost();
    this.updateSetupCost();
    this._changeRef.detectChanges();
  }

  updateRentalCost() {
    this.totalRentalCost = (this.itemControl.getRawValue() as IssueItem[]).reduce((agg, curr) => agg += curr.itemrentalcost * (typeof curr.itemcount === 'number' && curr.itemcount > 0 ? curr.itemcount : 1), 0);
  }

  updatePurchaseCost() {
    this.totalPurchaseCost = (this.itemControl.getRawValue() as IssueItem[]).reduce((agg, curr) => agg += curr.itempurchasecost * (typeof curr.itemcount === 'number' ? curr.itemcount : 0), 0);
  }

  updateSetupCost() {
    this.totalSetupCost = (this.itemControl.getRawValue() as IssueItem[]).reduce((agg, curr) => agg += curr.itemsetupcost * (typeof curr.itemcount === 'number' && curr.itemcount > 0 ? curr.itemcount : 1), 0);
  }

  get itemControl(): FormArray {
    return this.formGroup.controls['items'] as FormArray;
  }
}
